/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MlsId } from './MlsId';
import {
    MlsIdFromJSON,
    MlsIdFromJSONTyped,
    MlsIdToJSON,
} from './MlsId';

/**
 * 
 * @export
 * @interface MlsListingInfo
 */
export interface MlsListingInfo {
    /**
     * 
     * @type {string}
     * @memberof MlsListingInfo
     */
    mlsName: string;
    /**
     * 
     * @type {MlsId}
     * @memberof MlsListingInfo
     */
    mlsId?: MlsId;
    /**
     * 
     * @type {string}
     * @memberof MlsListingInfo
     */
    mlsListingId: string;
}

/**
 * Check if a given object implements the MlsListingInfo interface.
 */
export function instanceOfMlsListingInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mlsName" in value;
    isInstance = isInstance && "mlsListingId" in value;

    return isInstance;
}

export function MlsListingInfoFromJSON(json: any): MlsListingInfo {
    return MlsListingInfoFromJSONTyped(json, false);
}

export function MlsListingInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MlsListingInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mlsName': json['mls_name'],
        'mlsId': !exists(json, 'mls_id') ? undefined : MlsIdFromJSON(json['mls_id']),
        'mlsListingId': json['mls_listing_id'],
    };
}

export function MlsListingInfoToJSON(value?: MlsListingInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mls_name': value.mlsName,
        'mls_id': MlsIdToJSON(value.mlsId),
        'mls_listing_id': value.mlsListingId,
    };
}

